module.exports = __webpack_public_path__ + "static/media/161007-DSC04988-16_Small.37f186f5.jpg";